// extracted by mini-css-extract-plugin
module.exports = {"seoHeading":"_3xlGE","seoSubHeading":"_2ZA9y"};